export default "__VITE_ASSET__DWmdT9aq__"